import React, { lazy } from "react";
import AuthRoute from "../../components/auth/AuthRoute";
import RoleRoutes from "../RoleRoutes";

export const pathName = "/marketing-manager-executive";

export const paths = {
    dashboard: "/dashboard",
    reports: "/reports",
    master: "/master-data",
    budget: "/campaign-budget",
    addBudget: "/campaign-budget/add",
    addProject: "/project/add",
    editProject: "/project/edit/:projectId",
    search:"/search",
    portalLeads:"/portal-leads",
    superReceptionist:"/super-receptionist",
    smSite:"/issues2026",
};

export const landing = `${pathName}${paths.dashboard}`;
export const pages = {
    landing,
    reports: `${pathName}${paths.reports}`,
    master: `${pathName}${paths.master}`,
    budget: `${pathName}${paths.budget}`,
    target: `${pathName}${paths.target}`,
    addBudget: `${pathName}${paths.addBudget}`,
    portalLeads: `${pathName}${paths.portalLeads}`,
    superReceptionist: `${pathName}${paths.superReceptionist}`, 
    addProject: `${pathName}${paths.addProject}`,
    editProject: (id) => `${pathName}${paths.editProject.replace(":projectId", id)}`,
    smSite: `${pathName}${paths.smSite}`, 
};



export const menu = [
    {
        title: "Dashboard",
        to: landing,
    },
    {
        title: "Reports",
        to: pages.reports,
    },
    {
        title: "Master Data",
        to: pages.master,
    },
    {
        title: "Campaign Budget",
        to: pages.budget,
    },
    {
        title: "Portal Leads",
        to: pages.portalLeads,
    },
    {
        title: "Super Receptionist",
        to: pages.superReceptionist,
    },
    {
        title: "Sales Manager Site",
        to: pages.smSite,
    },
];

export const routes = [
    {
        path: paths.dashboard,
        component: lazy(() => import("../marketing-manager/Dashboard")),
    },

    {
        path: paths.reports,
        component: lazy(() => import("../marketing-manager/Reports")),
    },
    {
        path: paths.master,
        component: lazy(() => import("../marketing-manager/MasterData")),
    },
    {
        path: paths.addProject,
        component: lazy(() => import("../marketing-manager/AddProject")),
    },
    {
        path: paths.editProject,
        component: lazy(() => import("../marketing-manager/EditProject")),
    },
    {
        path: paths.budget,
        component: lazy(() => import("../marketing-manager/Budget")),
        exact: true,
    },
    {
        path: paths.addBudget,
        component: lazy(() => import("../marketing-manager/AddBudget")),
    },
    {
        path: paths.portalLeads,
        component: lazy(() => import("../marketing-manager/PortalLeads")),
    },
    {
        path: paths.superReceptionist,
        component: lazy(() => import("../marketing-manager/SuperReceptionist")),
    },
    {
        path: `${paths.search}/view/:leadId`,
        component: lazy(() => import("../tele-caller/LeadDetails")),
    },
    {
        path: paths.search,
        component: lazy(() => import("../OverallSearchResult")),
    },
    {
        path: paths.smSite,
        component: lazy(() => import("../marketing-manager/Salesmanagersite")),
    },
];

export const allowRoles = [10, 22];

export default (
    <AuthRoute path={pathName}>
        <RoleRoutes
            title="Marketing Manager Executive"
            routes={routes}
            menu={menu}
            landing={landing}
            allowRoles={allowRoles}
        />
    </AuthRoute>
);
